var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"main-container"}},[_c('v-layout',[_c('KitchenSink')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }